import React from 'react';
import StyledInput from '../../common/StyledInput.jsx';
import { s } from '../../Style.jsx';

const Options = ({ options, setOptions }) => {

    return <div style={s.box}>
        <div style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-end", padding: "0" }}>

            {(options || []).map((option, i) => <div style={{ width: "100%" }}>
                <div key={i} style={{ display: "flex", gap: 4, alignItems: "center", padding: "0" }}>
                    <input style={{ flex: 1 }} value={option?.name} onChange={e => setOptions(options.map((c, j) => i === j ? { ...c, name: e.target.value } : c))} />
                    <input style={{width:60}} type="number" value={option?.min} onChange={e => setOptions(options.map((c, j) => i === j ? { ...c, min: e.target.value } : c))} />
                    <input style={{width:60}} type="number" value={option?.max} onChange={e => setOptions(options.map((c, j) => i === j ? { ...c, max: e.target.value } : c))} />
                    <input style={{width:60}} value={option?.tag} onChange={e => setOptions(options.map((c, j) => i === j ? { ...c, tag: e.target.value } : c))} />
                    <s.ExitArrow does={() => setOptions(options.filter((c, j) => i !== j))} />
                </div>
            </div>)}

            <button onClick={() => setOptions([...(options || []), { name: "New Option" }])}>Add Option</button>

        </div>
    </div>;

}

export default Options;